/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional maximum capacity allowed for slot-level overrides.
 */
export type EventKindMaxCapacityOverride = number | null;
